module.exports = __webpack_public_path__ + "img/part-two.0f42e0d9.jpg";